// extracted by mini-css-extract-plugin
module.exports = {"back":"-KS18","back-container":"gCq+f"};